export default __webpack_public_path__ + "static/media/sheep4.ce7095ca.png";